import axios from 'axios';
import resolve  from './../resolver.js';
import checkJwt from './../../Global/jwtChecker' 
import logout from './../../Global/logout' 

export default async function CreateUser(
    state,
    props
) {
    const unHashedJwt = await checkJwt()    

    if(!unHashedJwt){
        logout()
    }

    let defaultColumn = {
        settings:{
            asideBg: false,
            asideColapsed: false,
            asideToggled: false,
            themeColor: 'darkBlue',        
            language: 'hr',
            customInvoiceFile: "" ,
            generickiPredlozakRacuna: true
        },

        columns: {
            provider:{
                main:{
                    full_name: false,
                    email: false,
                    phone_number: false,
                    address: false,
                    countries: false,
                    deleted: false,
                    created: false
                },
                user:{
                    email: false,
                    created: false,
                    enabled: false,
                    username: false,
                    last_name: true,
                    first_name: false,
                    user_non_expired: false,
                    account_non_locked: false,
                    account_non_expired: false
                },
                tax_rate: {
                    country: false,
                    tax_rate_mark: false,
                    tax_rate: false,
                    tax_rate_description: false
                }
            },

            client:{
                main: {
                    company_name: false,
                    company_legal_ID: false,
                    company_address: false,
                    company_VAT_ID: false,
                    company_place: false,
                    company_postal_code: false,
                    email: false,
                    phone_number: false,
                    login_domain: false,
                    in_VAT: false
                },
                business_premises: {
                    country: false,
                    deleted: false,
                    company_name: false,
                    business_premises_logo: false,
                    business_premises_mark: false,
                    business_premises_name: false,
                    business_premises_place: false,
                    business_premises_remark: false,
                    business_premises_address: false,
                    business_premises_postal_code: false
                },
                terminal: {
                    description: false,
                    business_premises: false,
                    tid: false,
                    created: false,
                    otp_valid_until: false,
                    roles: false,
                    enabled: false,
                    account_non_expired: false,
                    account_non_locked: false,
                    user_non_expired: false,
                    otp_is_valid: false
                },
                operator: {
                    client: false,
                    operator_username: false,
                    operator_mark: false,
                    operator_name: false,
                    operator_surname: false,
                    operator_ID: false
                },
                user: {
                    username: false,
                    email: false,
                    first_name: false,
                    last_name: false,
                    client: false,
                    deleted: false,
                    enabled: false,
                    account_non_expired: false,
                    account_non_locked: false
                }
            }
        }
    }

    return await resolve(
        axios( process.env.REACT_APP_DEFAULT_API_PREFIX + 'provider/createUser?providerUuid=' + props.oneProvider.uuid, {
            method: 'post',
            headers: {
                'Authorization' : unHashedJwt                 
            },
            data: {
                "username": state.username,
                "password": state.password,
                "email": state.email,
                "first_name": state.first_name,
                "last_name": state.last_name,
                "user_roles": ["POWERADMIN", "ADMIN"],
                "user_web_properties": defaultColumn,
                "oib": state.oib
            }      
        }).then(res => res)
        .catch(error => error.response.data)
    );
}